import { DateTime } from "luxon";
import DayPart from "../../day-part";
import DayPartHelper from "../day-part-helper";

class DayPartMonthly extends DayPart {
  constructor(props) {
    super(props);
    this._helper = new DayPartHelper(props, "months");
  }

  get _iterationStartDateTime() {
    return this._helper.beginDateTime;
  }

  get _iterationEndDateTime() {
    const iterationEnd = DateTime.fromFormat(
      `${this._helper.eventOptions.beginningDate} ${this._helper.eventOptions.endTime}`,
      "yyyy-MM-dd HH:mm:ss"
    );

    if (iterationEnd < this._helper.beginDateTime) {
      return DateTime.fromISO(iterationEnd).plus({ days: 1 });
    }
    return iterationEnd;
  }

  _matchesDayNumber() {
    return [this._iterationStartDateTime.toFormat("dd"), this._iterationEndDateTime.toFormat("dd")].includes(
      this._atTime.toFormat("dd")
    );
  }

  _matchesDay() {
    return super._matchesDay() && this._matchesDayNumber();
  }
}

export default DayPartMonthly;
